"use strict";

/* Copyright 2015-2020 The MathWorks, Inc. */
define(['dojo/dom', 'dojo/on', 'dojo/request/script', 'mw-log/Log'], function (dom, on, script, Log) {
  'use strict';
  /**
   * Checks to make sure we can load the js file specified by: urlToEmptyJs
   * Usage:
   * var checkUrlObj = checkUrlService(url).then(successCallback, errorCallback);
   * To cancel:
   *  checkUrlObj.cancel("Don't want to wait anymore - or another message", false);
   *  Do not call cancel if the object has already been resolved.  If unsure:
   *  isFulfilled() => is true (cancelled, rejected/error, completed)
   *
   * @param {string} urlToEmptyJsFile - url to a JS file that should have no executable code
   *                          (since otherwise it will execute)
   * @return {promise} A promise that has a true (if it loaded), error if the script
   *                   could not be loaded calling cancel (see above),  on the promise
   *                   will clean it up.
   */

  function checkUrl(urlToEmptyJsFile) {
    var options, errorEvent, deferred, node, handle;

    if (!urlToEmptyJsFile) {
      throw new Error('Expected a valid url in urlToEmptyJsFile');
    } // options.framedoc is used internally when locating script tag
    // explicitly set it is clear the script is in the default frame.


    options = {};
    options.framedoc = null;
    errorEvent = 'error';
    deferred = script.get(urlToEmptyJsFile, options, true);
    node = dom.byId(deferred.id, options.frameDoc);
    handle = on(node, errorEvent, function (evt) {
      Log.info('CheckUrlService detected an error accessing url: ' + urlToEmptyJsFile);
      deferred.handleResponse(null, evt);
      handle.remove();
    });
    return deferred.promise;
  }

  return checkUrl;
});
//# sourceMappingURL=CheckUrlService.js.map
